import {
    useMemo,
} from 'react'

import FormWithControls from 'app/shared-components/FormWithControls'
import requests from 'app/requests/Contact/Contact.requests'

import {
    SAPContactSyncForm,
} from '../ContactSAPContact.types'
import getSAPContactFields from './ContactSAPContactForm.fields'

type Props = {
    data: SAPContactSyncForm
    contactId: number
    refetch: () => void
}

const ContactSAPContactForm = ({
    data,
    contactId,
    refetch,
}: Readonly<Props>) => {
    const fields = useMemo(() => {
        return getSAPContactFields()
    }, [])

    return (
        <FormWithControls
            name="SAPContactSync"
            value={data}
            onSuccess={refetch}
            fields={fields}
            requestParams={requests.sapEmployee({
                id: contactId,
            })}
            exists
        />
    )
}

export default ContactSAPContactForm
